const { initAll } = require('.')

// Initialise components
document.addEventListener('DOMContentLoaded', () => initAll(document))
